module.exports = __webpack_public_path__ + "img/29.0543bf96.jpg";